<template>
  <el-dialog
    width="560px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="visibleDialog"
    append-to-body
  >
    <div class="dialog-wrap">
      <div class="tip-content">
        <div>
          1、在名单里的商家（商ID）可以通过爆版、OS商品库对承诺现货进行编辑，名单外的商家（按渠道商ID查款）承诺现货库存均更新为0，且各个端口不能编辑承诺现货。
        </div>
        <div>2、导入后替换原本的商家名单。</div>
        <div>3、导入的格式为：从A2~A无限，一个单元格一个商家ID。</div>
      </div>

      <div class="button-wrap">
        <el-upload
          style="margin-right: 12px"
          :action="importFileApi"
          :show-file-list="false"
          :auto-upload="true"
          name="excel"
          :on-success="importFileSuccess"
          with-credentials
        >
          <el-button type="primary" size="mini" icon="el-icon-top">
            导入白名单
          </el-button>
        </el-upload>

        <el-button
          type="success"
          size="mini"
          icon="el-icon-bottom"
          @click="handleExportFile"
        >
          导出白名单
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "CommittedSpotBlacklistDialog",
  data() {
    return {
      visibleDialog: false,
      importFileApi: `${apiBaseURL}/erp/Supply/importCommittedSpotBlacklist`,
    };
  },

  methods: {
    // 显示弹框
    showDialog() {
      this.visibleDialog = true;
    },
    // 成功导入
    importFileSuccess(data) {
      if (data.code !== 200) {
        this.$message.e(data.msg);
      } else {
        this.visibleDialog = false;
        this.$message.success("更新成功");
      }
    },
    // 导出黑名单
    handleExportFile() {
      this.$post("/erp/Supply/exportCommittedSpotBlacklist").then((rs) => {
        this.visibleDialog = false;
        window.open(apiBaseURL + rs.file);
      });
    },
  },
};
</script>

<style scoped>
.dialog-wrap {
  position: relative;
}

.dialog-wrap .button-wrap {
  display: flex;
  justify-content: flex-end;
  padding: 0 20px;
}

.dialog-wrap .tip-content {
  padding: 0 40px 20px;
}

.dialog-wrap .tip-content div {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/components/CommittedSpotBlacklistDialog.vue